export default __webpack_public_path__ + "static/media/arrow-down.1902382d.svg";